import React, {useState, useEffect, useContext} from 'react';
import {useTranslation} from 'react-i18next';

import NotFound from '../../../NotFound';
import PopupPDFEquipamento from './popUpPdfEquipamento';
import PictureAsPdfRoundedIcon from '@mui/icons-material/PictureAsPdfRounded';
import PdfGroupModalEquipamentos from './PdfGroupModalEquipamentos';
import InputFilter from '../../../Filters/InputFilter';
import SelectComponent from '../../../Selects/SelectFilter';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';

import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';
import LoadingModal from '../../../LoadingModal';
import Spinner from '../../../Spinner';
import {Context} from '../../../../Helpers/Auth';
import TablePagination from '../../../TablePagination';
import {getMaquinas, getMarcas, getNacionaisInternacionais, getVersoes} from '../../../../pages/requests';
import axios from 'axios';

function ParqueEquipamentos({info}) {
    const {t} = useTranslation();
    const {
        prospect,
        parqueEquipamentos,
        setParqueEquipamentos,
        equipamentosOutrasMarcas,
        utilizador,
        filtroNumEquipamento,
        setFiltroNumEquipamento,
        filtroNumSerie,
        setFiltroNumSerie,
        filtroArtigo,
        setFiltroArtigo,
        filtroMarca,
        setFiltroMarca,
        filtroNacionalInternacional,
        setFiltroNacionalInternacional,
        filtroTipo,
        setFiltroTipo,
        filtroModelo,
        setFiltroModelo,
        filtroVersao,
        setFiltroVersao,
        filtroEspecificacao,
        marcas,
        setMarcas,
        nacionaisInternacionais,
        setNacionaisInternacionais,
        tipos,
        setTipos,
        modelos,
        setModelos,
        versoes,
        setVersoes,
        setFiltroEspecificacao,
        filtroDescParque,
        setFiltroDescParque,
        setEquipamentosOutrasMarcas,
        editarProspect,
        currentPage,
        ITEMS_PER_PAGE,
        totalRegistos,
        setTotalRegistos,
        setCurrentPage,
    } = info;
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    const [semDados, setSemDados] = useState(false);
    const [idDocumento, setIdDocumento] = useState('');
    const [dataPdf, setDataPdf] = useState('');
    const [loading, setLoading] = useState(false);

    const [isMobile, setIsMobile] = useState(false);

    const [abrirTab, setAbrirTab] = React.useState(1);

    const {isCard, openCards} = useContext(Context);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    useEffect(() => {
        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;

        const codCliente = prospect?.codigoCliente;

        const controller = new AbortController();
        const signal = controller.signal;

        setParqueEquipamentos([]);
        getMaquinas(
            codCliente,
            lang,
            signal,
            indexOfFirstItem,
            indexOfLastItem - 1,
            filtroNumEquipamento,
            filtroDescParque,
            filtroNumSerie,
            filtroArtigo,
            filtroMarca?.value ?? '',
            filtroNacionalInternacional?.value ?? '',
            filtroTipo?.value ?? '',
            filtroModelo?.value ?? '',
            filtroVersao?.value ?? '',
        )
            .then(res => {
                setParqueEquipamentos(res.data.maquinas);
                setTotalRegistos(res.data.totalRegistos);
            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    console.log(error);
                }
            });

        return () => {
            controller.abort();
        };
    }, [currentPage, filtroNumEquipamento, filtroDescParque, filtroNumSerie, filtroArtigo, filtroMarca, filtroNacionalInternacional, filtroTipo, filtroModelo, filtroVersao]);

    // // FILTROS

    // const [filtroNumEquipamento, setFiltroNumEquipamento] = useState('');
    // const [filtroDescParque, setFiltroDescParque] = useState('');
    // const [filtroNumSerie, setFiltroNumSerie] = useState('');
    // const [filtroArtigo, setFiltroArtigo] = useState('');
    // const [filtroMarca, setFiltroMarca] = useState('');
    // const [filtroTipo, setFiltroTipo] = useState('');
    // const [filtroModelo, setFiltroModelo] = useState('');
    // const [filtroVersao, setFiltroVersao] = useState('');
    // const [filtroEspecificacao, setFiltroEspecificacao] = useState('');

    // // ARRAYS

    // const [marcas, setMarcas] = useState([]);
    // const [tipos, setTipos] = useState([]);
    // const [modelos, setModelos] = useState([]);
    // const [versoes, setVersoes] = useState([]);

    const rowCount = equipamentosOutrasMarcas.length;

    const handleResize = () => {
        setIsMobile(window.innerWidth < 900);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (parqueEquipamentos.length != 0 && semDadosEstado == false) {
            setSemDados(false);
        } else {
            setSemDados(true);
        }
    }, [parqueEquipamentos]);

    function handleChangeFiltro() {
        if (filtroNumEquipamento || filtroDescParque || filtroNumSerie || filtroArtigo || filtroMarca || filtroNacionalInternacional || filtroTipo || filtroModelo || filtroVersao) {
            return true;
        } else {
            return false;
        }
    }

    function limparFiltros() {
        setFiltroNumEquipamento('');
        setFiltroDescParque('');
        setFiltroNumSerie('');
        setFiltroArtigo('');
        setFiltroMarca(null);
        setFiltroNacionalInternacional(null);
        setFiltroTipo(null);
        setFiltroModelo(null);
        setFiltroVersao(null);
    }

    useEffect(() => {
        if (equipamentosOutrasMarcas.length == 0) {
            setEquipamentosOutrasMarcas([{nSerie: '', idLinha: Math.random() * 999999, descricao: '', marca: '', modelo: ''}]);
        }
    }, []);

    const addEquipamento = () => {
        setEquipamentosOutrasMarcas(prev => [
            ...prev,
            {
                nSerie: '',
                idLinha: Math.random() * 999999,
                descricao: '',
                marca: '',
                modelo: '',
            },
        ]);
    };

    const eliminarLinha = nSerie => {
        debugger;
        const novasLinhas = equipamentosOutrasMarcas.filter(equipamento => equipamento.nSerie !== nSerie);

        setEquipamentosOutrasMarcas(novasLinhas);
    };

    const handleChildChange = (e, id) => {
        const updatedData = [...equipamentosOutrasMarcas];
        updatedData[id] = e;
        setEquipamentosOutrasMarcas(updatedData);
    };

    return (
        <>
            <div>
                <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400">
                    <li className="me-2">
                        <a
                            aria-current="page"
                            onClick={() => {
                                setAbrirTab(1);
                            }}
                            className={`cursor-pointer inline-block p-4  rounded-t-[8px] active hover:text-gray-600  dark:hover:bg-gray-800 dark:hover:text-gray-300  ${
                                abrirTab === 1 ? 'dark:bg-gray-600 dark:text-blue-400 text-blue-600 bg-gray-100 ' : 'hover:bg-gray-100'
                            } `}>
                            {t('parqueMoviter')}
                        </a>
                    </li>
                    <li className="me-2">
                        <a
                            onClick={() => {
                                setAbrirTab(2);
                            }}
                            className={`cursor-pointer inline-block p-4 rounded-t-[8px] hover:text-gray-600  dark:hover:bg-gray-800 dark:hover:text-gray-300 ${
                                abrirTab === 2 ? 'dark:bg-gray-600 dark:text-blue-400 text-blue-600 bg-gray-100' : 'hover:bg-gray-100'
                            }`}>
                            {t('parqueOutrasMarcas')}
                        </a>
                    </li>
                </ul>
                <div className="bg-gray-100 dark:bg-gray-600 sm:rounded-[8px]">
                    {dataPdf != '' && <PopupPDFEquipamento back={() => setDataPdf('')} dataPdf={dataPdf}></PopupPDFEquipamento>}
                    {isMobile || isCard ? (
                        <>
                            {abrirTab === 1 && (
                                <div>
                                    {parqueEquipamentos?.map((produto, index) => (
                                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                            <h2 className="mb-0" id="headingOne">
                                                <button
                                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                                    type="button"
                                                    data-te-collapse-init
                                                    data-te-collapse-collapsed
                                                    data-te-target={'#flush-collapseThree' + index}
                                                    aria-expanded="false"
                                                    aria-controls="flush-collapseThree">
                                                    <span
                                                        onClick={() => {
                                                            setIdDocumento(produto.numEquipamento);
                                                        }}
                                                        className="flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                                        <AttachFileRoundedIcon />
                                                    </span>
                                                    <div className="flex flex-row">
                                                        {produto.numEquipamento} - {produto.descEquipamento}
                                                    </div>
                                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                                        </svg>
                                                    </span>
                                                </button>
                                            </h2>
                                            <div
                                                id={'flush-collapseThree' + index}
                                                className={openCards ? 'visible' : '!visible hidden'}
                                                data-te-collapse-item
                                                aria-labelledby="flush-headingThree"
                                                data-te-parent="#accordionFlushExample">
                                                <div className="px-5 py-4">
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('descricaoEquip')}:</div> {produto.descEquipamento}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('nuMSerieEquip')}: </div> {produto.numSerieEquipamento}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('artigo')}: </div> {produto.artigo}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('marca')}: </div> {produto.marca}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('nacionalInternacional')}: </div> {produto.nacionalInternacioal}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('tipo')}: </div> {produto.tipo}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('modelo')}: </div> {produto.modelo}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('versao')}: </div> {produto.versao}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>

                                    {loading && (
                                        <div className="flex flex-row mt-14 justify-center">
                                            <>
                                                <Spinner />
                                            </>
                                        </div>
                                    )}
                                    <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                                        <div>
                                            <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                                {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                                <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                            </span>

                                            <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                            <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                                        </div>
                                        <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                                    </nav>
                                </div>
                            )}
                            {abrirTab === 2 && (
                                <div>
                                    {equipamentosOutrasMarcas?.map((row, index) => (
                                        <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                            <h2 className="mb-0" id="headingOne">
                                                <button
                                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                                    type="button"
                                                    data-te-collapse-init
                                                    data-te-collapse-collapsed
                                                    data-te-target={'#flush-collapseThree' + index}
                                                    aria-expanded="false"
                                                    aria-controls="flush-collapseThree">
                                                    <div className="flex flex-row">
                                                        {row.nSerie} - {row.descricao}
                                                    </div>
                                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                                        </svg>
                                                    </span>
                                                </button>
                                            </h2>
                                            <div
                                                id={'flush-collapseThree' + index}
                                                className={openCards ? 'visible' : '!visible hidden'}
                                                data-te-collapse-item
                                                aria-labelledby="flush-headingThree"
                                                data-te-parent="#accordionFlushExample">
                                                <div className="px-5 py-4">
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('nuMSerieEquip')}: </div> {row.nSerie}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('descricaoEquip')}: </div> {row.descricao}
                                                    </div>
                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('marca')}: </div> {row.marca}
                                                    </div>

                                                    <div className="text-gray-500 flex flex-row">
                                                        <div className="font-medium text-gray-400 mr-2">{t('modelo')}: </div> {row.modelo}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div>

                                    {loading && (
                                        <div className="flex flex-row mt-14 justify-center">
                                            <>
                                                <Spinner />
                                            </>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    ) : (
                        <div className="relative min-h-[400px]  w-full overflow-x-auto shadow-md sm:rounded-b-[8px]  ">
                            <>
                                {abrirTab === 1 && (
                                    <>
                                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300 ">
                                                <tr>
                                                    <th scope="col" className=" py-3"></th>
                                                    <th scope="col" className="px-6 py-3">
                                                        {t('numeroEquipamento')}
                                                        <InputFilter
                                                            value={filtroNumEquipamento}
                                                            onSearch={value => {
                                                                setFiltroNumEquipamento(value);
                                                                setCurrentPage(1);
                                                            }}
                                                        />
                                                    </th>

                                                    <th scope="col" className="px-6 py-3 w-80">
                                                        {t('descricaoEquip')}
                                                        <InputFilter
                                                            value={filtroDescParque}
                                                            onSearch={value => {
                                                                setFiltroDescParque(value);
                                                                setCurrentPage(1);
                                                            }}
                                                        />
                                                    </th>
                                                    <th scope="col" className="px-6 py-3">
                                                        {t('nuMSerieEquip')}
                                                        <InputFilter
                                                            value={filtroNumSerie}
                                                            onSearch={value => {
                                                                setFiltroNumSerie(value);
                                                                setCurrentPage(1);
                                                            }}
                                                        />
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 ">
                                                        {t('artigo')}
                                                        <InputFilter
                                                            value={filtroArtigo}
                                                            onSearch={value => {
                                                                setFiltroArtigo(value);
                                                                setCurrentPage(1);
                                                            }}
                                                        />
                                                    </th>
                                                    <th scope="col" className="px-1 py-3 ">
                                                        {t('marca')}
                                                        <SelectComponent
                                                            options={marcas}
                                                            value={filtroMarca}
                                                            onChange={e => {
                                                                setFiltroMarca(e);
                                                                setCurrentPage(1);
                                                            }}
                                                            noOptionsMessage={t('semopcoes')}
                                                            placeholder={t('filtro')}
                                                        />
                                                    </th>
                                                    <th scope="col" className="px-6 py-3 ">
                                                        {t('nacionalInternacional')}
                                                        <SelectComponent
                                                            options={nacionaisInternacionais.filter(o => o.dep === filtroMarca?.value)}
                                                            value={filtroNacionalInternacional}
                                                            onChange={e => {
                                                                setFiltroNacionalInternacional(e);
                                                                setCurrentPage(1);
                                                            }}
                                                            noOptionsMessage={t('semopcoes')}
                                                            placeholder={t('filtro')}
                                                        />
                                                    </th>
                                                    <th scope="col" className=" py-3">
                                                        {t('tipo')}
                                                        <SelectComponent
                                                            options={tipos.filter(o => o.dep === filtroNacionalInternacional?.value)}
                                                            value={filtroTipo}
                                                            onChange={e => {
                                                                setFiltroTipo(e);
                                                                setCurrentPage(1);
                                                            }}
                                                            noOptionsMessage={t('semopcoes')}
                                                            placeholder={t('filtro')}
                                                        />
                                                    </th>
                                                    <th scope="col" className="px-4 py-3 ">
                                                        {t('modelo')}
                                                        <SelectComponent
                                                            options={modelos.filter(o => o.dep === filtroTipo?.value)}
                                                            value={filtroModelo}
                                                            onChange={e => {
                                                                setFiltroModelo(e);
                                                                setCurrentPage(1);
                                                            }}
                                                            noOptionsMessage={t('semopcoes')}
                                                            placeholder={t('filtro')}
                                                        />
                                                    </th>
                                                    <th scope="col" className="px-4 py-3 ">
                                                        {t('versao')}
                                                        <div className="flex flex-row">
                                                            <SelectComponent
                                                                options={versoes.filter(o => o.dep === filtroModelo?.value)}
                                                                value={filtroVersao}
                                                                onChange={e => {
                                                                    setFiltroVersao(e);
                                                                    setCurrentPage(1);
                                                                }}
                                                                noOptionsMessage={t('semopcoes')}
                                                                placeholder={t('filtro')}
                                                            />
                                                            {handleChangeFiltro() ? (
                                                                <button
                                                                    onClick={limparFiltros}
                                                                    type="button"
                                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                                    <FilterAltOffIcon />
                                                                </button>
                                                            ) : null}
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {parqueEquipamentos.map(produto => (
                                                    <tr className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 ">
                                                        <th className="px-4  py-1 font-medium text-gray-900  dark:text-white">
                                                            <span
                                                                data-modal-target="defaultModal"
                                                                data-modal-toggle="defaultModal"
                                                                onClick={() => {
                                                                    setIdDocumento(produto.numEquipamento);
                                                                }}
                                                                className="flex text-xs  items-center justify-center h-6 font-xs text-blue-600 rounded-[8px] hover:text-blue-800 dark:text-blue-500 dark:hover:text-blue-600 ">
                                                                <AttachFileRoundedIcon />
                                                            </span>
                                                        </th>
                                                        <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                            {produto.numEquipamento}
                                                        </th>
                                                        <td className="px-6 py-1">{produto.descEquipamento}</td>
                                                        <td className="px-6 py-1">{produto.numSerieEquipamento}</td>
                                                        <td className="px-6 py-1">{produto.artigo}</td>
                                                        <td className="px-2 py-1">{produto.marca}</td>
                                                        <td className="px-2 py-1">{produto.nacionalInternacioal}</td>
                                                        <td className="px-6 py-1">{produto.tipo}</td>
                                                        <td className="px-6 py-1">{produto.modelo}</td>
                                                        <td className="px-6 py-1">{produto.versao}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                        {semDados && !loading && <NotFound frase={t('semRegistos')} />}
                                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                                            <div>
                                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalRegistos / ITEMS_PER_PAGE)}</span>
                                                </span>

                                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalRegistos}</span>
                                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                                            </div>
                                            <TablePagination total={totalRegistos} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                                        </nav>
                                    </>
                                )}
                                {abrirTab === 2 && (
                                    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                                        <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300 ">
                                            <tr>
                                                <th scope="col" className="px-6 py-3">
                                                    {t('nuMSerieEquip')}
                                                </th>

                                                <th scope="col" className="px-12 py-3 ">
                                                    {t('descricaoEquip')}
                                                </th>

                                                <th scope="col" className="px-12 py-3 ">
                                                    {t('marca')}
                                                </th>

                                                <th scope="col" className="px-12 py-3 ">
                                                    {t('modelo')}
                                                </th>
                                                <th scope="col" className="px-2 py-3 "></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {equipamentosOutrasMarcas.map((row, rowIndex) => (
                                                <tr className="bg-white border-b cursor-pointer dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700">
                                                    <th scope="row" className="px-6 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                        <input
                                                            type="text"
                                                            value={row.nSerie}
                                                            placeholder={t('nuMSerieEquip')}
                                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700`}
                                                            onChange={e => {
                                                                row.nSerie = e.target.value;
                                                                handleChildChange(row, rowIndex);
                                                            }}
                                                            disabled={!editarProspect}
                                                        />
                                                    </th>
                                                    <td className="px-12 py-1">
                                                        <input
                                                            type="text"
                                                            value={row.descricao}
                                                            placeholder={t('descricaoEquip')}
                                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700`}
                                                            onChange={e => {
                                                                row.descricao = e.target.value;
                                                                handleChildChange(row, rowIndex);
                                                            }}
                                                            disabled={!editarProspect}
                                                        />
                                                    </td>
                                                    <td className="px-12 py-1">
                                                        {' '}
                                                        <input
                                                            type="text"
                                                            value={row.marca}
                                                            placeholder={t('marca')}
                                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700`}
                                                            onChange={e => {
                                                                row.marca = e.target.value;
                                                                handleChildChange(row, rowIndex);
                                                            }}
                                                            disabled={!editarProspect}
                                                        />
                                                    </td>
                                                    <td className="px-12 py-1">
                                                        {' '}
                                                        <input
                                                            type="text"
                                                            value={row.modelo}
                                                            placeholder={t('modelo')}
                                                            className={`block w-full text-sm mt-2 p-1 pl-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-[5px] shadow-sm dark:bg-gray-900 dark:border-gray-700`}
                                                            onChange={e => {
                                                                row.modelo = e.target.value;
                                                                handleChildChange(row, rowIndex);
                                                            }}
                                                            disabled={!editarProspect}
                                                        />
                                                    </td>
                                                    <td className="px-2 py-4">
                                                        {rowCount === rowIndex + 1 && row.descricao !== '' && editarProspect && (
                                                            <a
                                                                // disabled={!editarProspect}
                                                                className={`mt-2 rounded-full p-1 ${'bg-blue-600'} text-white cursor-pointer`}
                                                                onClick={e => {
                                                                    e.stopPropagation();
                                                                    addEquipamento();
                                                                }}>
                                                                <AddRoundedIcon />
                                                            </a>
                                                        )}
                                                        {rowCount != rowIndex + 1 && editarProspect && (
                                                            <a
                                                                className={`mt-2 rounded-full p-1 ${'bg-red-600'} text-white cursor-pointer`}
                                                                onClick={e => {
                                                                    e.preventDefault();
                                                                    eliminarLinha(row.nSerie);
                                                                }}>
                                                                <DeleteForeverRoundedIcon />
                                                            </a>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </>
                            {/* <div className="mb-4">{semDados && <NotFound frase={t('semRegistos')} />}</div> */}
                        </div>
                    )}
                </div>
            </div>
            {idDocumento != '' && (
                <PdfGroupModalEquipamentos
                    dataPdf={dataPdf}
                    setDataPdf={setDataPdf}
                    setLoading={setLoading}
                    loading={loading}
                    idEquipamento={idDocumento}
                    back={() => {
                        setIdDocumento('');
                    }}
                />
            )}
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <LoadingModal />
                    </>
                </div>
            )}
        </>
    );
}

export default ParqueEquipamentos;
